import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

// ** Reactstrap Imports
import { Card, CardBody, Row, Col } from 'reactstrap';

export const VerticalShimmer = () => {
    return (
        <SkeletonTheme baseColor="#F5F5F5" highlightColor="#e0e0e0">
            <Card
                style={{
                    width: '270px',
                    minHeight: '100vh',
                    maxHeight: '100vh',
                    overflowY: 'scroll',
                    overflowX: 'hidden',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none'
                }}
            >
                <CardBody style={{ padding: '1rem', display: 'flex', flexDirection: 'column' }}>
                    <Row>
                        <Col lg="4" md="4" sm="6" xs="12">
                            <div className="d-flex align-items-start about-col-gap">
                                <div className="d-flex full-width flex-column gap-0">
                                    <Skeleton height={45} width={240} />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Row 1 */}
                    <Row style={{ marginTop: '10px', paddingLeft: '5px' }}>
                        <Col lg="4" md="4" sm="6" xs="12">
                            <div className="d-flex align-items-start about-col-gap">
                                <Skeleton height={30} width={30} style={{ marginRight: '1px', borderRadius: '5px' }} />

                                <div className="d-flex full-width flex-column gap-0">
                                    <Skeleton height={30} width={187} />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Rows 2 to 20  */}
                    {(() => {
                        const rows = [];
                        for (let i = 2; i <= 20; i++) {
                            rows.push(
                                <Row key={i} style={{ marginTop: '10px', paddingLeft: '5px' }}>
                                    <Col lg="4" md="4" sm="6" xs="12">
                                        <div className="d-flex align-items-start about-col-gap">
                                            <Skeleton height={30} width={30} style={{ marginRight: '1px', borderRadius: '5px' }} />
                                            <div className="d-flex full-width flex-column gap-0">
                                                <Skeleton height={30} width={187} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            );
                        }
                        return rows;
                    })()}
                </CardBody>
            </Card>
        </SkeletonTheme>
    );
};

export default VerticalShimmer;
